import { Component, OnInit } from '@angular/core';
import { AuthService } from './services/auth.service';
import { Router } from '@angular/router';
import { ApiService } from '@app-services/api.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  title = 'angular-front';

  constructor(private authService: AuthService, private router: Router, public apiService: ApiService) { }

  ngOnInit(): void { 
    //Implement a subscription to apiService.loading and console log the loading state
    this.apiService.loading$.subscribe(loading => {
    });   
  }
}
